import React from "react";
import { useParams } from "react-router";
// import HeadLayout from "./head-layout";
import InvoiceTransfer from "../../apps/fe/invoice-transfer";
import Header from "./header";
import PageTitle from "./pageTitle";
import Aside from "./aside";

const Container = () => {
    const { page } = useParams();
    const renderPage = ( page ) => {
        switch ( page )
        {
            case "invoice-fiscal-transfer":
                return <InvoiceTransfer ncfTypeCode={31} />
            case "invoice-transfer":
                return <InvoiceTransfer ncfTypeCode={32} />
            case "invoice-special-regimen-transfer":
                return <InvoiceTransfer ncfTypeCode={44} />
            case "invoice-governmental-transfer":
                return <InvoiceTransfer ncfTypeCode={45} />
            case "invoice-export-transfer":
                return <InvoiceTransfer ncfTypeCode={46} />
            default:
                return <p>Page isnt rendering...</p>
        } 
    }
    const asideList = ( page ) => {
        const feNavLi = [
            {
                key: 'fcfe',
                label: "Factura de Crédito Fiscal Electrónica",
                uri: "/nadmin-invoice-fiscal-transfer"
            },
            {
                key: 'fce',
                label: "Factura de Consumo Electrónica",
                uri: "/nadmin-invoice-transfer"
            },
            {
                key: 'free',
                label: "Factura para Regímenes Especiales Electrónico",
                uri: "/nadmin-invoice-special-regimen-transfer"
            },
            {
                key: 'fge',
                label: "Facturas Gubernamentales Electrónicas",
                uri: "/nadmin-invoice-governmental-transfer"
            },
            {
                key: 'fee',
                label: "Factura de Exportación Electrónica",
                uri: "/nadmin-invoice-export-transfer"
            }
        ];
        switch ( page )
        {
            case "none":
                return <p>Page isnt rendering...</p>
            default:
                return feNavLi
        }
    }
    const pageTitle = ( page ) => {
        let title = "";
        switch ( page )
        {
            case "invoice-fiscal-transfer":
                title = "Factura de Crédito Fiscal Electrónica";
                break
            case "invoice-transfer":
                title = "Factura de Consumo Electrónica";
                break;
            case "invoice-special-regimen-transfer":
                title = "Factura para Regímenes Especiales Electrónico";
                break
            case "invoice-governmental-transfer":
                title = "Facturas Gubernamentales Electrónicas";
                break
            case "invoice-export-transfer":
                title = "Factura de Exportación Electrónica";
                break
            default:
                title = "";
                break
        } 
        return (
            <PageTitle 
                title={title}
                navLi={[
                    {
                        key: "li-key-1",
                        label: "Inicio"
                    },
                    {
                        key: "li-key-2",
                        label: title,
                        active: true
                    }
                ]}
            />
        )
    }
    return (
        <>
            <Header />

            {/* Miss aside */}
            <Aside navLi={asideList(page)} />

            <main id="main" className="main">

                {pageTitle(page)}

                <section className="section">
                    {renderPage(page)}
                </section>

            </main>
        </>
    )
}

export default Container;